import { render } from "./HorizontalIconForm.vue?vue&type=template&id=54634f28"
import script from "./HorizontalIconForm.vue?vue&type=script&lang=js"
export * from "./HorizontalIconForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__